import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Modal from 'components/ui/Modal';
import { ConfirmButton } from 'components/ui/Button';

import { StyledAbandonButton } from '../OnHoldCancellationModal/OnHoldCancellationModal.styles';

const ThirdPartyBookingCancellationModal = ({ isOpen, isLoading, onToggle, onSubmit }) => (
  <Modal
    isOpen={isOpen}
    title={<FormattedMessage id="manageBooking.cancelRefundThirdParty" />}
    subtitle={<FormattedMessage id="manageBooking.cancelRefundThirdPartyMessage" />}
    onClose={onToggle}
  >
    <ConfirmButton onClick={onSubmit} loading={isLoading} disabled={isLoading}>
      <FormattedMessage id="manageBooking.confirmCancellation" />
    </ConfirmButton>

    <StyledAbandonButton onClick={onToggle} disabled={isLoading}>
      <FormattedMessage id="manageBooking.abandonCancellation" />
    </StyledAbandonButton>
  </Modal>
);

ThirdPartyBookingCancellationModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func,
  onSubmit: PropTypes.func
};

export default ThirdPartyBookingCancellationModal;
